import { render, staticRenderFns } from "./MyStep.vue?vue&type=template&id=b6ab76d8&scoped=true&"
import script from "./MyStep.vue?vue&type=script&lang=js&"
export * from "./MyStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ab76d8",
  null
  
)

export default component.exports